import { api } from '../client/api';

// =============================================================================
// 콘텐츠의 소유 그룹 (2026-09-17 대교)
//
// "오너는 다른 그룹 플레이리스트를 생성할 수 있어야 함, 라이브러리·슬라이드 등 모두 업로드·이동
//  등이 가능해야 함."
//
// 만들 때는 생성 모달이 ownerGroupId 를 함께 보내고, 이미 만든 것은 '수정' 모달의 이 칸으로 옮긴다.
// 자리를 따로 만들지 않은 이유: 이름을 고치러 여는 그 모달이 이미 '이 콘텐츠를 손보는 곳'이라,
// 메뉴를 하나 더 늘리는 것보다 찾기 쉽다. 공개/비공개가 있던 자리이기도 하다.
//
// 공유 여부(sharedToAll)는 건드리지 않는다 — 화면에서 사라진 개념이라 지금 값을 그대로 돌려보낸다.
// 서버 classify() 도 공유 변경을 조직 Owner로 제한하므로 그대로 보내는 편이 안전하다.
// =============================================================================

export type OwnedContent = {
  id: string;
  ownerGroupId?: string | null;
  sharedToAll?: boolean;
  revision?: number;
};

/** 이 콘텐츠의 소유 그룹을 화면 값('' = 공통)으로. 소유 개념이 없는 조직이면 null. */
export function ownerGroupOf(item: OwnedContent): string | null {
  return item.ownerGroupId === undefined ? null : item.ownerGroupId ?? '';
}

/**
 * 소유 그룹이 바뀌었으면 저장한다. **다른 필드 저장보다 먼저** 불러야 한다 — 어떤 UPDATE든
 * scope_revision 을 올리는 트리거가 있어(contentScopeSchema) 나중에 부르면 409가 난다.
 */
export async function applyOwnerGroup(
  kind: 'media' | 'playlist' | 'notice',
  item: OwnedContent,
  next: string | null,
): Promise<boolean> {
  if (next === null || (next || null) === (item.ownerGroupId ?? null)) return false;
  if (!Number.isInteger(item.revision)) throw new Error('소유 정보를 다시 불러와 주세요.');
  await api.moveContentGroup(kind, item.id, {
    ownerGroupId: next || null,
    sharedToAll: item.sharedToAll === true,
    expectedRevision: item.revision!,
  });
  return true;
}

export function ContentOwnerGroupField({ value, onChange, groups, noun, allowCommon = true }: {
  /** '' = 공통(중앙 소유). */
  value: string;
  onChange: (next: string) => void;
  groups: Array<{ id: string; name: string }>;
  noun: string;
  /** 중앙만 '공통'에 둘 수 있다. 여러 그룹을 맡은 구성원은 자기 그룹 중에서만 고른다. */
  allowCommon?: boolean;
}): JSX.Element {
  return (
    <label className="block">
      <span className="block font-mono text-[12px] font-medium uppercase tracking-monoWide text-text-dim mb-1.5">소유 그룹</span>
      <select
        value={value}
        onChange={(event) => onChange(event.target.value)}
        className="w-full h-9 bg-bg border border-line rounded px-2 text-[14px] text-text"
        aria-label="소유 그룹"
      >
        {allowCommon && <option value="">공통 (중앙 소유 · 모든 그룹에서 편성 가능)</option>}
        {groups.map((group) => <option key={group.id} value={group.id}>{group.name}</option>)}
      </select>
      <span className="mt-1.5 block text-[12px] text-text-dim leading-[1.5]">
        고른 그룹의 관리자·편집자가 이 {noun}를 쓸 수 있습니다.{allowCommon ? ' 공통은 모든 그룹에서 씁니다.' : ''}
      </span>
    </label>
  );
}
